export default __webpack_public_path__ + "static/media/favicon.a2ed4a70.ico";